// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95afa8b8","455":"c1511f6a","977":"3b5be8bf"}[chunkId] + ".chunk.js";
};